import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { usePreview } from '../contexts/PreviewContext';
import Announcements from './Announcements';

// SVG icons for sub-app options
const SubAppIcons = {
  portfolio_dashboard: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="4" rx="1" /><rect x="14" y="10" width="7" height="7" rx="1" /><rect x="3" y="13" width="7" height="4" rx="1" />
      <line x1="5" y1="6" x2="8" y2="6" /><line x1="16" y1="13" x2="19" y2="13" /><line x1="16" y1="15" x2="18" y2="15" />
    </svg>
  ),
  portfolio_viewer: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 21H4a1 1 0 01-1-1V3" /><path d="M7 14l4-4 4 4 5-5" /><circle cx="20" cy="9" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  research_reports: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" />
    </svg>
  ),
  fund_screener: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /><line x1="8" y1="11" x2="14" y2="11" /><line x1="11" y1="8" x2="11" y2="14" />
    </svg>
  ),
  portfolio_blender: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2v4l-2 2v6a4 4 0 008 0V8l-2-2V2" /><line x1="8" y1="2" x2="14" y2="2" /><path d="M7 10h8" />
    </svg>
  ),
  portfolio_constructor: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><polyline points="12,6 12,12 16,14" />
    </svg>
  ),
  portfolio_comparison: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="2" x2="12" y2="22" /><path d="M17 8l-5-5-5 5" /><rect x="3" y="10" width="7" height="8" rx="1" /><rect x="14" y="6" width="7" height="12" rx="1" />
    </svg>
  ),
  portfolio_lab: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 3v3l-3 4v4a5 5 0 0010 0v-4l-3-4V3" /><line x1="9" y1="3" x2="16" y2="3" /><path d="M8 13h9" /><circle cx="11" cy="16" r="1" fill="currentColor" stroke="none" /><circle cx="14" cy="15" r="0.7" fill="currentColor" stroke="none" />
    </svg>
  ),
  portfolio_optimiser: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 21H4a1 1 0 01-1-1V3" /><path d="M7 16l4-6 4 2 5-8" /><circle cx="7" cy="16" r="1.5" fill="currentColor" stroke="none" /><circle cx="20" cy="4" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  fact_sheets: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" /><line x1="8" y1="9" x2="10" y2="9" />
    </svg>
  ),
  portfolio_reports: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /><rect x="8" y="12" width="2" height="5" /><rect x="11" y="10" width="2" height="7" /><rect x="14" y="13" width="2" height="4" />
    </svg>
  ),
  investment_perspectives: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /><polyline points="7.5,16.5 10.5,13 13,15 16.5,10.5" /><circle cx="16.5" cy="10.5" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  ),
  portfolio_attribution: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="5" x2="4" y2="19" />
      <line x1="4" y1="7" x2="14" y2="7" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="17" x2="10" y2="17" />
    </svg>
  ),
};

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { theme } = useTheme();
  const { previewData, isPreviewMode } = usePreview();
  const [selectedTile, setSelectedTile] = useState(null);

  // Define available apps - 4 main tiles, 2 with sub-apps
  const apps = [
    {
      id: 'resources',
      name: 'Resources',
      description: 'Documents, files, and links',
      icon: '📁',
      path: '/apps/resources',
      subApps: null,
    },
    {
      id: 'portfolio_views',
      name: 'Portfolio Views',
      description: 'View and analyse model portfolios',
      icon: '📈',
      path: null,
      subApps: [
        { id: 'portfolio_dashboard', name: 'Portfolio Dashboard', description: 'Overview of all model portfolios', path: '/apps/portfolio-dashboard', icon: '📊' },
        { id: 'portfolio_viewer', name: 'Portfolio Viewer', description: 'View portfolio allocations and exposures', path: '/apps/portfolio-viewer', icon: '📈' },
      ],
    },
    {
      id: 'reporting',
      name: 'Reporting',
      description: 'Portfolio reporting and fact sheets',
      icon: '📄',
      path: null,
      subApps: [
        { id: 'fact_sheets', name: 'Fact Sheets', description: 'Generate branded portfolio fact sheets', path: '/apps/factsheets', icon: '📄' },
        { id: 'portfolio_reports', name: 'Portfolio Reports', description: 'Generate portfolio performance reports', path: '/apps/portfolio-reports', icon: '📊' },
        { id: 'investment_perspectives', name: 'Investment Perspectives', description: 'Monthly market commentary report', path: '/apps/investment-perspectives', icon: '📰' },
      ],
    },
    {
      id: 'fund_research',
      name: 'Fund Research',
      description: 'Fund research and performance reports',
      icon: '📋',
      path: null,
      subApps: [
        { id: 'research_reports', name: 'Research Reports', description: 'Fund research and performance reports', path: '/apps/research-reports', icon: '📊' },
        { id: 'fund_screener', name: 'Fund Screener', description: 'Fund screening and comparison tools', path: '/apps/fund-screener', icon: '🔍' },
        { id: 'manager_summary', name: 'Manager Summary', description: 'Manager Summary Tables', path: '/apps/manager-summary', icon: '📈' },
        { id: 'quant_screener', name: 'Quant Screener', description: 'Quantitative manager screening and scoring', path: '/apps/quant-screener', icon: '🧮' },
      ],
    },
    {
      id: 'apps',
      name: 'Apps',
      description: 'Portfolio analysis and construction tools',
      icon: '🛠️',
      path: null,
      subApps: [
        { id: 'portfolio_blender', name: 'Portfolio Blender', description: 'Portfolio analysis and stochastic projections', path: '/apps/portfolio-blender', icon: '⚗️' },
        { id: 'portfolio_constructor', name: 'Portfolio Backtester', description: 'Build and analyse custom portfolios', path: '/apps/portfolio-constructor', icon: '⏱️' },
        { id: 'portfolio_lab', name: 'Portfolio Lab', description: 'Build custom portfolios and compare', path: '/apps/portfolio-lab', icon: '🧪' },
        { id: 'allocation_calculator', name: 'Allocation Calculator', description: 'Build a client allocation from portfolios, funds and cash', path: '/apps/allocation-calculator', icon: '🧮' },
        { id: 'market_data', name: 'Market & Economic Data', description: 'Chart and analyse market data series', path: '/apps/market-data', icon: '📊' },
      ],
    },
    {
      id: 'drummond_internal',
      name: 'Drummond Internal',
      description: 'Internal portfolio tools and analysis',
      icon: '🔒',
      path: null,
      // Grouped into columns (Quant / TAA / Portfolio Trading / Portfolio Monitoring / Misc) for the modal.
      subApps: [
        // Quant
        { id: 'investment_config', group: 'Quant', name: 'Investment Config', description: 'Asset classes, CMA, portfolios, and stress testing', path: '/apps/investment-config', icon: '⚙️' },
        { id: 'portfolio_optimiser', group: 'Quant', name: 'Portfolio Optimiser', description: 'Mean-variance portfolio optimisation', path: '/apps/portfolio-optimiser', icon: '📐' },
        { id: 'risk_model', group: 'Quant', name: 'Risk Model', description: 'Sub-asset class risk decomposition', path: '/apps/risk-model', icon: '🎯' },
        { id: 'backtest_dashboard', group: 'Quant', name: 'Signal Dashboard', description: 'Tactical signal backtest analysis', path: '/apps/backtest-dashboard', icon: '📡' },
        { id: 'db_explorer', group: 'Quant', name: 'DB Explorer', description: 'Browse RDS database tables (read-only)', path: '/apps/db-explorer', icon: '🗄️' },
        // TAA
        { id: 'tactical_monitor', group: 'TAA', name: 'Tactical Monitor', description: 'IC asset-allocation signal monitor and positioning', path: '/apps/tactical-monitor', icon: '🧭' },
        { id: 'growth_barometer', group: 'TAA', name: 'Growth Barometer', description: 'Regional Coincident Activity Index (CAI) z-scores', path: '/apps/growth-barometer', icon: '🌡️' },
        { id: 'sector_heatmap', group: 'TAA', name: 'Sector Heatmap', description: 'Sector and country earnings momentum vs valuation percentiles', path: '/apps/sector-heatmap', icon: '🔥' },
        { id: 'chart_pack', group: 'TAA', name: 'Chart Pack', description: 'Pre-built market and economic charts: earnings revisions, momentum, bonds and the US, AU and CN economies', path: '/apps/chart-pack', icon: '📚' },
        // Portfolio Trading
        { id: 'portfolio_trading', group: 'Portfolio Trading', name: 'Portfolio Trading', description: 'Set target weights, diff vs previous, and generate execution instructions', path: '/apps/trading', icon: '📋' },
        { id: 'drift_monitoring', group: 'Portfolio Trading', name: 'Drift Monitoring & Post Trade Compliance', description: 'Approved trading targets vs platform holdings — drift, execution failures, exceptions', path: '/apps/drift-monitoring', icon: '⚖️' },
        // Portfolio Monitoring
        { id: 'portfolio_attribution', group: 'Portfolio Monitoring', name: 'Portfolio Attribution', description: 'Brinson decomposition, contributions, and holdings analysis', path: '/apps/portfolio-attribution', icon: '🔬' },
        { id: 'tailored_taa_monitoring', group: 'Portfolio Monitoring', name: 'Tailored TAA Monitoring', description: 'Tailored suite target weights vs SAA at asset-class-group level, with the growth-matched Drummond tilt band', path: '/apps/tailored-taa-monitoring', icon: '🎯' },
        { id: 'plus_fund', group: 'Portfolio Monitoring', name: 'Plus Fund', description: 'Dynamic Plus Fund IB holdings, exposure vs DDP, rebalancing, performance and the APL security master', path: '/apps/plus-fund', icon: '➕' },
        { id: 'analyst_portfolios', group: 'Portfolio Monitoring', name: 'Analyst Portfolios', description: 'Investment team analyst books vs DS70: holdings, history, attribution, mandate checks and the Refinitiv upload', path: '/apps/analyst-portfolios', icon: '👥' },
        // Misc (remainder)
        { id: 'projects', group: 'Misc', name: 'Projects', description: 'Track RFPs, due diligence, implementations & research', path: '/apps/projects', icon: '🗂️' },
        { id: 'portfolio_comparison', group: 'Misc', name: 'Portfolio Comparison', description: 'Compare portfolios side by side', path: '/apps/portfolio-comparison', icon: '⚖️' },
      ],
    },
    {
      id: 'retirement_calculator',
      name: 'Retirement Calculator',
      description: 'Retirement income modelling and projections',
      icon: '🏦',
      path: '/apps/retirement-calculator',
      subApps: null,
    },
    {
      id: 'cpd',
      name: 'CPD',
      description: 'Continuing professional development',
      icon: '🎓',
      path: '/apps/cpd',
      subApps: null,
    },
    // SOA Builder — hidden until ready for release
    // {
    //   id: 'soa_builder',
    //   name: 'SOA Builder',
    //   description: 'Generate Statements of Advice',
    //   icon: '📝',
    //   path: '/apps/soa-builder',
    //   subApps: null,
    // },
  ];

  // Use preview allowed_apps if in preview mode, otherwise use user's allowed_apps
  const userAllowedApps = isPreviewMode && previewData
    ? previewData.allowed_apps
    : user?.allowed_apps || [];

  // Filter apps based on user permissions
  // Show tile if user has access to it directly OR to any of its sub-apps
  const allowedApps = apps.filter((app) => {
    if (app.subApps) {
      return app.subApps.some((sub) => userAllowedApps.includes(sub.id));
    }
    return userAllowedApps.includes(app.id);
  });

  // Handle tile click - open modal for tiles with sub-apps, navigate directly otherwise
  const handleTileClick = (e, app) => {
    if (app.subApps) {
      setSelectedTile(app);
    }
    // Direct-path tiles are handled by the <Link> wrapper
  };

  // Handle sub-app selection from modal
  const handleSubAppClick = () => {
    setSelectedTile(null);
  };

  // Get allowed sub-apps for the selected tile (permission-filtered)
  const getAllowedSubApps = (tile) => {
    if (!tile?.subApps) return [];
    return tile.subApps.filter((sub) => userAllowedApps.includes(sub.id));
  };

  // Column order + per-column accent for the grouped Drummond Internal modal.
  const DRUMMOND_COLUMN_ORDER = ['Quant', 'TAA', 'Portfolio Trading', 'Portfolio Monitoring', 'Misc'];
  const DRUMMOND_COLUMN_ACCENT = {
    Quant: '#5E819C',                  // slate blue
    TAA: '#337B91',                    // teal
    'Portfolio Trading': '#012341',    // navy
    'Portfolio Monitoring': '#12706C', // dark teal
    Misc: '#A6C6C1',                   // sage
  };

  const renderSubApp = (subApp) => (
    <Link
      key={subApp.id}
      className="sub-app-option-premium animate-slide-in-right"
      style={{ textDecoration: 'none', color: 'inherit' }}
      to={subApp.path}
      onClick={() => handleSubAppClick()}
    >
      <div className="sub-app-icon-wrapper">
        {SubAppIcons[subApp.id] || <span className="sub-app-icon">{subApp.icon}</span>}
      </div>
      <div className="sub-app-content">
        <h6 className="sub-app-title">{subApp.name}</h6>
        <p className="sub-app-description">{subApp.description}</p>
      </div>
      <div className="sub-app-arrow">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </div>
    </Link>
  );

  return (
    <div className="dashboard-container">
      <div className="dashboard-grid">
        {/* Left column - Apps (4 tiles in 2x2 grid) */}
        <div className="dashboard-apps">
          <div className="apps-grid">
            {allowedApps.map((app, index) => {
              const tileContent = (
                <>
                  <div className="app-tile-icon-wrapper">
                    <span className="app-tile-icon">{app.icon}</span>
                  </div>
                  <h5 className="app-tile-title">{app.name}</h5>
                  <p className="app-tile-description">{app.description}</p>
                </>
              );
              return app.path ? (
                <Link
                  key={app.id}
                  className="app-tile-premium animate-fade-up"
                  style={{ animationDelay: `${index * 0.1}s`, textDecoration: 'none', color: 'inherit' }}
                  to={app.path}
                >
                  {tileContent}
                </Link>
              ) : (
                <div
                  key={app.id}
                  className="app-tile-premium animate-fade-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onClick={(e) => handleTileClick(e, app)}
                >
                  {tileContent}
                </div>
              );
            })}
          </div>
        </div>

        {/* Right column - Announcements (larger) - only shown if user has announcements permission */}
        {userAllowedApps.includes('announcements') && (
          <div className="dashboard-announcements animate-fade-up" style={{ animationDelay: '0.2s' }}>
            <Announcements />
          </div>
        )}
      </div>

      {/* Sub-App Selection Modal */}
      {selectedTile && (
        <div
          className="modal-premium-overlay animate-fade-in"
          onClick={() => setSelectedTile(null)}
        >
          <div
            className={`modal-premium-content animate-scale-in${selectedTile.id === 'drummond_internal' ? ' modal-premium-content--grid' : ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-premium-header">
              <h5 className="modal-premium-title">
                <span className="modal-premium-icon">{selectedTile.icon}</span>
                {selectedTile.name}
              </h5>
              <button
                type="button"
                className="modal-premium-close"
                onClick={() => setSelectedTile(null)}
                aria-label="Close"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="modal-premium-body">
              {selectedTile.id === 'drummond_internal'
                ? DRUMMOND_COLUMN_ORDER.map((group) => {
                    const groupApps = getAllowedSubApps(selectedTile).filter((s) => s.group === group);
                    if (groupApps.length === 0) return null;
                    return (
                      <div className="sub-app-column" key={group} style={{ '--col-accent': DRUMMOND_COLUMN_ACCENT[group] }}>
                        <h6 className="sub-app-column-header">{group}</h6>
                        {groupApps.map(renderSubApp)}
                      </div>
                    );
                  })
                : getAllowedSubApps(selectedTile).map(renderSubApp)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
